import { Component } from '@angular/core';

@Component({
    templateUrl: './law-library-preview.component.html',
    styleUrls: ['./law-library-preview.component.scss'],
    standalone: false
})

export class LawLibraryPreviewComponent {
    constructor(
    ) { }
}